import { render } from "./Main.vue?vue&type=template&id=a9425bd4&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=a9425bd4&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-a9425bd4"

export default script